enum PermitCreatedBy {
	Undefined = 0,
	PublicWeb = 1,
	BasicMaintenance = 2
}

export default PermitCreatedBy;
